import { render, staticRenderFns } from "./VsPassword.vue?vue&type=template&id=39fbf98a&scoped=true&lang=html&"
import script from "./VsPassword.vue?vue&type=script&lang=js&"
export * from "./VsPassword.vue?vue&type=script&lang=js&"
import style0 from "./VsPassword.vue?vue&type=style&index=0&id=39fbf98a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fbf98a",
  null
  
)

export default component.exports